<template>
  <div class="banner1">
    <div>请添加1~12张图片，推荐尺寸180*80。可拖动排序</div>
    <draggable
      v-model="currentInfo.wxSchoolPageItemList"
      @update="datadragEndContent"
      :options="{ animation: 500 }"
    >
      <div
        class="mt20"
        v-for="(item, index) in currentInfo.wxSchoolPageItemList"
        :key="index"
      >
        <div class="flex mt10 jc-sb wx-item-style">
          <el-upload
            :action="fileObj.url"
            :before-upload="beforeUpload"
            :on-success="successListUpdate"
            :headers="reqData"
            :show-file-list="false"
          >
            <img
              class="list-img"
              :src="item.picture"
              @click="updateImg(index)"
              v-if="item.picture"
            />
            <div @click="updateImg(index)" v-else class="addIcon">
              <i class="el-icon-plus" />
            </div>
          </el-upload>

          <el-button type="danger" @click="deleteBtn(index)" v-if="item.picture"
            >删除<i class="el-icon-delete"
          /></el-button>
        </div>
      </div>
    </draggable>
  </div>
</template>
<script>
import { codeMixin } from "../../../minix";
export default {
  mixins: [codeMixin],
  methods: {
    deleteBtn(index) {
      this.currentInfo.wxSchoolPageItemList[index].picture = "";
      this.currentInfo.wxSchoolPageItemList[index].isEmpty = 1;
    },
  },
};
</script>
<style lang="less" scoped>
.banner1 {
  /deep/ .el-upload {
    width: 180px;
    height: 80px;
    .list-img {
      width: 180px;
      height: 80px;
      object-fit: cover;
    }
  }
  .addIcon {
    width: 180px;
    height: 80px;
    line-height: 90px;
    box-sizing: border-box;
    border: 1px dashed #fff;
    .el-icon-plus {
      font-size: 36px;
    }
  }
  .jc-sb {
    padding: 10px;
    border-radius: 6px;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/other/other2/setting.vue